import React from "react"
import { Link } from "gatsby"

/*Material-ui */
import { Grid, Typography, Button } from "@material-ui/core"
import { makeStyles, withStyles } from "@material-ui/core/styles"

/*Local files */
import Person from "../images/6031.png"
import BackDuo from "../images/Trazado_unido.png"
const useStyles = makeStyles({
  ContenedorMain: {
    backgroundColor: "#F0F0F0",
    width: "100%",
    height: "560px",
    "@media (max-width: 720px)": {
      height: "auto",
      overflowX: "hidden",
    },
  },
  container: {
    "@media (max-width: 720px)": {
      flexDirection: "column",
    },
  },
  Titulo1: {
    color: "#385099",
    fontSize: "55px",
    marginTop: "2.5rem",
    textAlign: "left",
    font: "700 45px/55px Montserrat",
    width: "100%",
    "@media (max-width: 720px)": {
      width: "90%",
      fontSize: "30px",
      marginTop: '12vh',

    },
  },
  titulo1Sub: {
    color: "#16B1CB",
  },
  persona: {
    marginLeft: "10%",
  },
  textoParrafo: {
    color: "#191919",
    width: "100%",
    marginTop: "2rem",
    fontSize: "35px",
    font: "300 25px/30px Montserrat",
    marginBottom: "2rem",
    "@media (max-width: 720px)": {
      width: "55%",
      fontSize: "25px",
      marginTop: "0",
    },
  },
  contenedorTexto: {
    marginTop: "-15rem",
    "@media (max-width: 720px)": {
      marginTop: "0",
      minWidth: "100%",
      display: "flex",
      justifyContent: "center",
    },
  },
  contenedorTextoImagen: {
    "@media (max-width: 720px)": {
      marginTop: "-360px",
      width: "90%",
    },
  },
  contenedorImagen: {
    backgroundImage: `url(${BackDuo})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    "@media (max-width: 720px)": {
      display: "none",
    },
  },
  contenedorImagenresponsivo: {
    backgroundImage: `url(${BackDuo})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    display: "none",
    "@media (max-width: 720px)": {
      display: "flex",
      backgroundSize: "90% 65%",
      backgroundPosition: "top left",
      minWidth: "100%",
      marginLeft: "40%",
    },
  },
  ContenedorWhite: {
    backgroundColor: "white",
    height: "200px",
    "@media (max-width: 720px)": {
      height: "auto",
      marginBottom: "100px",
    },
  },
  TextoWhite: {
    "@media (max-width: 720px)": {
      minWidth: "90%",
    },
  },
  Titulowhite: {
    color: "#385099",
    marginTop: "1.5rem",
    fontSize: "37px",
    font: "700 30px/37px Montserrat",
    "@media (max-width: 720px)": {
      fontSize: "28px",
    },
  },
  Parrafowhite: {
    textAlign: "left",
    color: "black",
    fontSize: "19px",
    width: "85%",
    font: "300 17px/20px Montserrat",
    "@media (max-width: 720px)": {
      width: "90%",
    },
  },
  coontenedorButtons: {
    "@media (max-width: 720px)": {
      marginTop: "-150px",
    },
  },
  buttons: {
    "@media (max-width: 720px)": {
      display: "flex",
      justifyContent: "center",
    },
  },
  SubtituloNorm: {
    font: "700 25px/30px Montserrat",
  },
})

const StyledButton = withStyles({
  root: {
    background:
      "transparent linear-gradient(90deg, #4267CB 0%, #16B1CB 100%) 0% 0% no-repeat padding-box",
    borderRadius: "27px",
    border: 0,
    color: "white",
    height: 48,
    width: "194px",
    padding: "0 30px",
    boxShadow: "0px 3px 6px #0000006A",
    "@media (max-width: 720px)": {
      padding: "0 10px",
      width: "163px",
      height: "49px",
      borderRadius: "50px",
      font: "800 18px Montserrat",
    },
    "@media (max-width: 480px)": {
      marginLeft: "50px",
      width: "150px",
    },
  },
  label: {
    textTransform: "none",
    fontFamily: "Helvetica",
    font: "700 17px/20px Montserrat",
  },
})(Button)

const StyledButtonLarge = withStyles({
  root: {
    background:
      "transparent linear-gradient(90deg, #4267CB 0%, #16B1CB 100%) 0% 0% no-repeat padding-box",
    borderRadius: "27px",
    border: 0,
    color: "white",
    height: 48,
    width: "220px",
    padding: "0 30px",
    boxShadow: "0px 3px 6px #0000006A",
    "@media (max-width: 720px)": {
      padding: "0 10px",
      width: "198px",
      height: "49px",
      borderRadius: "50px",
      font: "700 17px/20px Montserrat",
    },
  },
  label: {
    textTransform: "none",
    fontFamily: "Helvetica",
    font: "700 17px/20px Montserrat",
  },
})(Button)

const SectionOne = () => {
  const classes = useStyles()
  return (
    <div>
      <Grid className={classes.ContenedorMain}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          xs={12}
          className={classes.container}
        >
          <Grid
            item
            xs={5}
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            className={classes.contenedorTexto}
          >
            <Typography className={classes.Titulo1}>
              ¡Que no te agarren las prisas, ni las
              <span className={classes.titulo1Sub}> multas </span> !
            </Typography>
            <Grid
              xs={7}
              container
              direction="row"
              justify="center"
              alignItems="center"
              className={classes.contenedorImagenresponsivo}
            >
              <img src={Person} className={classes.persona} alt="Persona" />
            </Grid>
            <Grid className={classes.contenedorTextoImagen}>
              <Typography className={classes.textoParrafo}>
                Aún estás a tiempo de cumplir <br /> con la
                <strong className={classes.SubtituloNorm}>
                  {" "}
                  norma 035 STPS-2018
                </strong>
              </Typography>
            </Grid>
            <Grid
              xs={12}
              container
              direction="row"
              justify="center"
              alignItems="center"
              className={classes.coontenedorButtons}
            >
              <Grid xs={4} md={6} className={classes.buttons}>
                <Link
                  to="#QueEsLaNorma"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <StyledButtonLarge id="INTERESADO">
                    ¿De qué se trata?
                  </StyledButtonLarge>
                </Link>
              </Grid>
              <Grid xs={6} md={6} className={classes.buttons}>
                <Link to="/Paquetes" style={{ textDecoration: "none" }}>
                  <StyledButton id="LEAD1">Ver paquetes</StyledButton>
                </Link>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            xs={6}
            container
            direction="row"
            justify="center"
            alignItems="center"
            className={classes.contenedorImagen}
          >
            <img src={Person} className={classes.persona} alt="Persona" />
          </Grid>
        </Grid>
      </Grid>
      <Grid className={classes.ContenedorWhite}>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          xs={12}
        >
          <Grid
            item
            xs={4}
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            className={classes.TextoWhite}
          >
            <Typography className={classes.Titulowhite}>
              Sin multas + Fácil + Accesible
            </Typography>
            <p className={classes.Parrafowhite}>
              Evita pagar costosas multas de hasta $434,000 por persona usando
              una plataforma fácil y profesional, a un costo accesible
            </p>
          </Grid>
          <Grid xs={7} />
        </Grid>
      </Grid>
    </div>
  )
}

export default SectionOne
